import notification from './main';

export default notification;
